import { useState, useEffect, useRef } from "react";

const screensDefault = {
	isMobile: false,
	isTablet: false,
	isDesktop: false,
};

export default function useResponsive() {
	const [screens, setScreens] = useState({
		...screensDefault,
		isDesktop: true,
	});
	const resizeTimeoutRef = useRef<any>(null);

	const handleResize = () => {
		const windowWidth = window.innerWidth;
		if (windowWidth <= 640) {
			setScreens({ ...screensDefault, isMobile: true });
		} else if (640 < windowWidth && windowWidth <= 1024) {
			setScreens({ ...screensDefault, isTablet: true });
		} else {
			setScreens({ ...screensDefault, isDesktop: true });
		}
	};

	const resizeDebounce = () => {
		if (resizeTimeoutRef.current) {
			clearTimeout(resizeTimeoutRef.current);
		}
		resizeTimeoutRef.current = setTimeout(() => {
			handleResize();
		}, 500);
	};

	useEffect(() => {
		handleResize();

		window.addEventListener("resize", resizeDebounce);
		return () => {
			window.removeEventListener("resize", resizeDebounce);
		};
	}, []);

	return screens;
}
